import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateUserCollectionGroupMutationVariables = Types.Exact<{
  data: Types.CreateUserCollectionGroupInput;
}>;


export type CreateUserCollectionGroupMutation = { createUserCollectionGroup: { group: { id: string, name: string } } };


export const CreateUserCollectionGroupDocument = /*#__PURE__*/ gql`
    mutation createUserCollectionGroup($data: CreateUserCollectionGroupInput!) {
  createUserCollectionGroup(data: $data) {
    group {
      id
      name
    }
  }
}
    `;

export function useCreateUserCollectionGroupMutation() {
  return Urql.useMutation<CreateUserCollectionGroupMutation, CreateUserCollectionGroupMutationVariables>(CreateUserCollectionGroupDocument);
};